export default {
  EXTRA_WIDE: '1546',
  WIDE: '1310',
  WIDE_MEDIUM: '1042',
  MEDIUM: '861',
  NARROW_MEDIUM: '688',
  NARROW: '453',
  EXTRA_NARROW: '237'
};
